import * as React from "react";
import { browserHistory } from "react-router";
import Component from "../../AbstractComponent";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import CompanyLookup from "../../Partials/Lookup/CompanyLookup";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
// import { Danger } from "../../Partials/Alert/Alerts/Danger";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import AgencyFeeContainer from "../../../Entity/Entities/AgencyFee/AgencyFeeContainer";
import { Timeline } from "../../Partials/Timeline/Timeline";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import PropertyUpdateWillMount from "../../../Middleware/Middlewares/PropertyUpdateWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { Attachment } from "../../Partials/Attachment/Attachment";
import Select from "../../Partials/Material/Select";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Divider from '@material-ui/core/Divider';
import * as ReactTooltip from 'react-tooltip'
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { BalanceComponent } from "../../Partials/Balance/BalanceComponent";
import { CoachDialog } from "../../Partials/Dialog/CoachDialog";
import { CoachPoaDialog } from  "../../Partials/Dialog/CoachPoaDialog";
import { BankAccountInterface } from "../../../Entity/Entities/BankAccount/BankAccountInterface";
import { BankAccountCreate } from "../../Partials/Dialog/BankAccountCreate";
import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import { AgencyFeeCreate } from "../../Partials/Dialog/AgencyFeeCreate";
import { AgencyFeeUpdate } from "../../Partials/Dialog/AgencyFeeUpdate";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import { ChargeTemplateCreate } from "../../Partials/Dialog/ChargeTemplateCreate";
import { ChargeTemplateUpdate } from "../../Partials/Dialog/ChargeTemplateUpdate";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import AssignmentServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import ChargeCreateDialog from "../../Partials/Dialog/ChargeCreateDialog";
import Memo from "../../Partials/Memo/Memo";
import EntityLaunchpanel from "../../Partials/Launchpanel/EntityLaunchpanel";
import ChargeTemplateCard from "../../Partials/ChargeTemplate/ChargeTemplateCard";
import UnitCard from "../../Partials/Unit/UnitCard";
import PropertyCard from "../../Partials/Property/PropertyCard";
import CreateTaskDialog from "../../Partials/Dialog/CreateTaskDialog";
import CoachNewCharge from "../../Partials/Dialog/CoachNewCharge";
import { CoachNewUnitDialog } from "../../Partials/Dialog/CoachNewUnitDialog";

class PropertyUpdate extends Component {
  private selectedAgencyFee: AgencyFeeInterface;
  private selectedUnit: UnitInterface;
  public noteField: null;
  protected unitsPaginatorPath: string;

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_PROPERTY_UPDATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    PropertyUpdateWillMount,
    PreventPageLeave
  ];

  public state = {
    property: null,
    unitNumber: "",
    unitType: 1,
    id: null,
    address: {
      formattedAddress: ""
    },
    company: null,
    companyId: null,
    contactId: null,
    contact: null,
    dialogOpen: false,
    amazonFolderName: null,
    errorMessage: "",
    openLeavePrompt: false,
    relateWithCompanyId: null,
    relateWithPersonId: null,
    note: "",
    isPromptOpen: false,
    entity: null,
    showNoChargesDialog: false,
    showOnlyInactiveDeletingDialog: false,
    memoPopupOpen: false,
    currentUnit: null,
    unitNote: "",
    hasModifiedData: false,
    nextPath: "",
    currentTenant: "",
    currentActivityTemplate: null,
    maxCharacterNumberForNotePopupOpen: false,
    isCreateTasksFromActivityTemplatePopupOpen: false,
    postProcessMessage: "",
    postProcessPopupOpen: false,
    removedPayments: [],
    paymentsFailedToRemove: [],
    deletedCharge: null,
    selectedTabIndex: 0,
    agencyBankAccountId: "",
    isCreateBankAccountDialogOpen: false,
    isUpdating: false,
    isAgencyFeeDialogOpen: false,
    beta: false,
    isChargeUlinkPopupOpen: false,
    isAgencyRemoveDialog: false,
    agencyFee: null,
    anchorElUnits: null,
    anchorElAgencyFees: null,
    charges: [],
    events: [],
    tasks: [],
    fetchingEvents: true,
    fetchingTasks: true,
    isSaving: false,
    selectedPerson: null,
    selectedCompany: null,
    attachments: [],
    removed: false,
    contactInformationOfAssociation: "",
    selectedAssociationOwner: null,
    anchorPropertyEl: null,
    isDeletePromptOpen: false,
    complexName: "",

    // charge templates
    chargeTemplates: [],
    isChargeTemplatePopupOpen: false,
    newChargeTemplatePopupOpen: null,
    anchorElChargeTemplate: null,
    selectedChargeTemplate: null,

    openPropertyOwnerCoachDialog: false,
    openPrePropertyOwnerCoachDialog: false,
    ownerType: "company",
    ownerTypeСhose: true,
    defaultCompanyName: "",
    openPoaCoachDialog: false,
    defaultPoaCompanyName: "",
    cannotDeleteSavingsChargeDialog: false,
    isChargeCreatePopupOpen: false,
    isCoachNewChargeOpen: false,
    isNewTaskForPropertyPopupOpen: false,
    isNewTaskForUnitPopupOpen: false,
    openCoachCreateNewUnit: false,


    // Default agreement
    vat: "",
    fixedFee: "",
    percentageFee: "",
    fixedPlusPercentageMode: this.props.globalTypes?.FixedPlusPercentageModes?.[this.defaultFixedPlusPercentageModes("FPP_both")],
    agreementVat: "",
    vatPercentage: "",
    chargeTypeIds: [TypeContainer.pickIdFromLabel("Basic_rent")],
    repeatPeriod: PeriodContainer.pickIdFromLabel("monthly"),
    assignmentServiceStatus: AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial"),
    currency: this.props.app.settings.user.currency.getCurrencyId(),
  };

  constructor(public props) {
    super(props);
  }

  public initializePage = (property: PropertyInterface) => {
    if (!property) {
      return this.redirectBack();
    }

    this.unitsPaginatorPath = `PropertyUnits_${property.id}`;

    this.props.dispatch({
      type: Constants.PAGE_PROPERTY_UPDATE_CLEAR
    });

    this.fetchPropertyCharges(property.id);
    this.fetchEntityEvents(property.id);

    let selectedTabIndex = this.props.app.propertyUpdatePageTabIndex;
    if(property?.id !== this.props.app?.selectedPropertyId) {
      selectedTabIndex = 0;

      this.props.dispatch({
        type: Constants.PAGE_PROPERTY_UPDATE_SWITCH_TAB,
        payload: {
          index: 0
        }
      });
    }

    const usingBeta = this.props && this.props.app && this.props.app.settings && this.props.app.settings.user && this.props.app.settings.user.beta;

    const agencyFee = property?.defaultAgencyFees[0];
    let vatPercentage = "";

    if (agencyFee && agencyFee.fixedFee) {
      const vatPercentageNumber = Math.round(agencyFee.vat / (agencyFee.fixedFee - agencyFee.vat) * 100);

      if (!isNaN(vatPercentageNumber)) {
        vatPercentage = this.formatter.simpleFormatNumber(vatPercentageNumber, false, false);
      }
    }

    let state = {
      property: property,
      id: property.id,
      note: property.note,
      companyId: property.companyId,
      contactId: property.contactId,
      address: property.address,
      company: property.company,
      contact: property.contact,
      attachments: property.attachments,
      selectedTabIndex: selectedTabIndex,
      agencyBankAccountId: property.agencyBankAccount || "",
      beta: usingBeta,
      selectedPerson: property.manager,
      selectedCompany: property.company,
      selectedAssociationOwner: property.associationOwner,
      executorId: property.manager ? property.managerId : null,
      removed: property.removed,
      contactInformationOfAssociation: property.contactInformationOfAssociation,
      complexName: property.complexName,

      // charge templates
      chargeTemplates: property.chargeTemplates,
      isChargeTemplatePopupOpen: false,
      newChargeTemplatePopupOpen: null,
      anchorElChargeTemplate: null,
      selectedChargeTemplate: null,

      vat: agencyFee?.vat,
      selectedAgencyFee: property?.defaultAgencyFees[0],
      agencyFee: agencyFee,
      currency: agencyFee ? agencyFee.currency.getCurrencyId() : this.props.app.settings.user.currency.getCurrencyId(),
      fixedFee: agencyFee && ((!agencyFee.fixedFee && agencyFee.fixedFee !== 0) ? "" : this.formatter.simpleFormatNumber(agencyFee.fixedFee)),
      percentageFee: agencyFee ? this.formatter.simpleFormatNumber(agencyFee?.percentageFee, false) : "",
      fixedPlusPercentageMode: agencyFee ? agencyFee.fixedPlusPercentageMode : this.props.globalTypes?.FixedPlusPercentageModes?.[this.defaultFixedPlusPercentageModes("FPP_both")],
      agreementVat: agencyFee ? (!agencyFee.vat ? "" : this.formatter.simpleFormatNumber(agencyFee.vat)) : "",
      vatPercentage: vatPercentage ? vatPercentage : "",
      chargeTypeIds: agencyFee?.chargeTypeIds || [TypeContainer.pickIdFromLabel("Basic_rent")],
      repeatPeriod: agencyFee?.repeatPeriod ? agencyFee?.repeatPeriod : PeriodContainer.pickIdFromLabel("monthly"),
      assignmentServiceStatus: agencyFee?.assignmentServiceStatus,
      isConcept: agencyFee?.isConcept,
      agreementRemoved: agencyFee?.removed
    };

    if (Object.keys(this.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdPerson = this.props.app.savedDataBeforeRedirecting.createdPerson;
      const createdExecutor = this.props.app.savedDataBeforeRedirecting.createdExecutor;
      const createdCompany = this.props.app.savedDataBeforeRedirecting.statePropertyName === "owner" ? this.props.app.savedDataBeforeRedirecting.createdCompany : null;
      const createdAssociationOwner = this.props.app.savedDataBeforeRedirecting.statePropertyName === "associationOwner" ? this.props.app.savedDataBeforeRedirecting.createdCompany : null;

      state = {
        ...state,
        ...this.props.app.savedDataBeforeRedirecting.propertyUpdateDataToBeSaved,
        selectedPerson: !!createdPerson ? createdPerson : this.props.app.savedDataBeforeRedirecting.propertyUpdateDataToBeSaved?.selectedPerson,
        selectedCompany: !!createdCompany ? createdCompany : this.props.app.savedDataBeforeRedirecting.propertyUpdateDataToBeSaved?.selectedCompany,
        executorId: !!createdExecutor ? createdExecutor.id : this.props.app.savedDataBeforeRedirecting.propertyUpdateDataToBeSaved?.executorId,
        selectedAssociationOwner: !!createdAssociationOwner ? createdAssociationOwner : this.props.app.savedDataBeforeRedirecting.propertyUpdateDataToBeSaved?.selectedAssociationOwner
      }
    }

    this.setState({
      ...state
    }, () => {
      this.props.dispatch({
        type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
      });
    });
  }

  public componentWillReceiveProps(nextProps) {
    const prevId = parseInt(this.props.params.id, 10);
    const id = parseInt(nextProps.params.id, 10);
    const property: PropertyInterface = nextProps.properties.byId[id];

    if (prevId !== id) {
      this.initializePage(property);
    } else {
      this.setState({
        property: property,
        chargeTemplates: !!property ? [...property.chargeTemplates] : [],
        attachments: !!property ? property.attachments : []
      });
    }
  }

  public fetchEntityEvents = (entityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        propertyId: entityId
      },
      onSuccess: data => {
        const propertyEvents: EventInterface[] = data.events
          .filter((event: EventInterface) => !event.removed);
        this.setState({
          events: [...propertyEvents],
          fetchingEvents: false
        });
      }
    });
  }

  public handleCreatedPerson = (person: PersonInterface): void => {
    this.setState({
      relateWithPersonId: person.id
    });
  }

  public handleCreatedCompany = (company: CompanyInterface): void => {
    this.setState({
      relateWithCompanyId: company.id
    });
  }

  public selectPerson = (person: PersonInterface, isManuallySelected: boolean): void => {
    this.setState({
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData,
      relateWithPersonId: person.id,
      selectedPerson: person,
    });
  }

  public selectCompany = (company: CompanyInterface, isManuallySelected: boolean): void => {
    this.setState({
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData,
      relateWithCompanyId: company.id,
      selectedCompany: company
    });
  }


  public selectAssociationOwner = (company: CompanyInterface, isManuallySelected: boolean): void => {
    this.setState({
      selectedAssociationOwner: company,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData
    });
  }

  public clearAssociationOwner = (): void => {
    this.setState({
      selectedAssociationOwner: null,
      hasModifiedData: true
    });
  }

  public clearPerson = (): void => {
    // (this.refs.PersonLookup as any).refs.instance.clear();

    this.setState({
      hasModifiedData: true,
      selectedPerson: null
    });
  }

  public clearCompany = (): void => {
    this.setState({
      hasModifiedData: true,
      selectedCompany: null
    });
  }

  protected unitDelete = (unit: UnitInterface) => {
    this.props.dispatch({
      type: Constants.GLOBAL_UNIT_DELETE_START,
      payload: {
        unit: unit,
        propertyId: unit.propertyId
      }
    });
  }

  public focusPerson = (): void => {
    (this.refs.CompanyLookup as any).refs.instance.hide();
  }

  public save = () => {
    // In this page, we save default agency fee.
    if (this.state.selectedTabIndex === 2) {
      this.setState({
        isSaving: true
      })
      const payload = {
        id: this.state.agencyFee?.id,
        objectType: this.state.agencyFee ? this.state.agencyFee?.objectType : AgencyFeeContainer.pickIdFromLabel("Property"),
        objectId: this.state.agencyFee ? this.state.agencyFee?.objectId : this.state.property.id,
        currency: this.state.currency,
        fixedFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2)),
        percentageFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.percentageFee)).replace(",", ".")).toFixed(2)),
        vat: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state?.agreementVat)).replace(",", ".")).toFixed(2)),
        fixedPlusPercentageMode: this.state.fixedPlusPercentageMode?.id,
        chargeTypeIds: this.state.chargeTypeIds,
        repeatPeriodId: this.state.repeatPeriod,
        serviceStatusId: this.state.assignmentServiceStatus,
      };
      if (payload.id) {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.GLOBAL_AGENCY_FEE_UPDATE_DEFAULT_START,
            payload: {
              ...payload
            },
            onSuccess: (agencyFee: AgencyFeeInterface) => {
              this.setState({
                hasModifiedData: false,
                isSaving: false,
                agencyFee: agencyFee
              })
            },
            onError: () => {
              this.setState({
                hasModifiedData: true,
                isSaving: false
              })
            }
          });
        });
      } else {
        delete payload.id;
        this.props.dispatch({
          type: Constants.GLOBAL_AGENCY_FEE_CREATE_DEFAULT_START,
          payload: payload,
          onSuccess: (agencyFee: AgencyFeeInterface) => {
            this.setState({
              hasModifiedData: false,
              isSaving: false,
              agencyFee: agencyFee
            })
          },
          onError: () => {
            this.setState({
              hasModifiedData: true,
              isSaving: false
            })
          }
        });
      }
    } else {
      this.saving(() => {
        this.props.dispatch({
          type: Constants.PAGE_PROPERTY_UPDATE_START,
          payload: {
            id: this.state.id,
            property: {
              address: { ...this.state.address },
              companyId: !this.state.selectedCompany ? null : this.state.selectedCompany.id,
              managerId: !this.state.selectedPerson ? null : this.state.selectedPerson.id,
              note: this.state.note,
              contactInformationOfAssociation: this.state.contactInformationOfAssociation,
              associationOwnerId: !this.state.selectedAssociationOwner ? null : this.state.selectedAssociationOwner.id,
              complexName: this.state.complexName
            }
          },
          onSuccess: () => {
            this.props.dispatch({
              type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
            });
  
            if (this.state.nextPath) {
              return this.redirect(this.state.nextPath);
            }
  
            this.redirectBack();
          },
          onError: () => {
            this.setState({
              isSaving: false,
              hasModifiedData: true
            });
          }
        });
      });
    }
  }

  public done = (): void => {
    this.redirectBack();
  }

  public closePrompt = (): void => {
    this.setState({
      isPromptOpen: false,
      isAgencyRemoveDialog: false
    });
  }

  public changeActiveStatus = (unit: UnitInterface) => {
    this.closeMenuUnits();

    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_UNIT_SET_ACTIVE_START,
        payload: {
          active: unit.isInactive,
          unitId: unit.id
        },
        onSuccess: () => {
          this.setState({
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public delete = (): void => {
    this.closePrompt();

    if (this.state.entity.nameOfEntity === this.trans("property")) {
      return this.propertyDelete(this.state.entity);
    }

    if (this.state.entity.nameOfEntity === this.trans("unit")) {
      return this.unitDelete(this.state.entity);
    }
  }

  protected propertyDelete = (property: PropertyInterface) => {
    this.props.dispatch({
      type: Constants.PAGE_PROPERTY_DELETE_START,
      payload: {
        property: property
      },
      onSuccess: () => {
        this.closeDeletePrompt();
        this.redirectBack();
      }
    });
  }

  public getTipText = (tip: string) => {
    const tipLength = 30;

    if (tip.length > tipLength) {
      return `${tip.slice(0, tipLength)}...`;
    }

    return tip;
  }

  public renderTasksIcon = (unit: UnitInterface) => {
    if (unit.countOfUnfinishedTasks) {
      return (
        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <span
            data-tip={unit.countOfOverdueTasks ?
                        this.trans("page/unitlist-tooltip/taskicon-overdueunfinished", {
                          unfinished: unit.countOfUnfinishedTasks,
                          overdue: unit.countOfOverdueTasks
                        }) :
                        this.trans("page/unitlist-tooltip/taskicon-unfinished", {
                          unfinished: unit.countOfUnfinishedTasks
                        })
                     }
          >
            <div
              style={{color: unit.countOfOverdueTasks ? "red" : "#00BCD4"}}
              className="icon icon-ic-task"
              onClick={e => {
                e.stopPropagation();
                this.redirect(`/app/unit/update/${unit.id}/`);
              }}>
            </div>
          </span>
          <ReactTooltip place="bottom" />
        </div>
      );
    }
  }

  public renderUnitAlertIcon = (unit: UnitInterface) => {
    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>

        {unit.note !== "" && (
          <span>
            <span data-tip={this.getTipText(unit.note)}>
              <div className="icon icon-ic-note blue-onhover"
                onClick={e => {
                  e.stopPropagation();
                  this.openMemoPopup(unit);
                }}
              >
              </div>
            </span>
            <ReactTooltip place="bottom" />
          </span>
          )
        }
      </div>
    );
  }

  protected openMenuUnits = (event: any, unit: UnitInterface): void => {
    this.selectedUnit = unit;

    this.setState({
      anchorElUnits: event.currentTarget
    });
  }

  protected closeMenuUnits = (): void => {
    this.setState({
      anchorElUnits: null
    });
  }

  protected openMenuAgencyFees = (event: any, agencyFee: AgencyFeeInterface): void => {
    this.selectedAgencyFee = agencyFee;

    this.setState({
      anchorElAgencyFees: event.currentTarget
    });
  }

  protected closeMenuAgencyFees = (): void => {
    this.setState({
      anchorElAgencyFees: null
    });
  }

  protected getUnits = () => {
    const emptyUnits = Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id]).filter((unit: UnitInterface) => unit.isEmpty);

    return this.state.property && this.state.property.units
    .sort((x: UnitInterface, y: UnitInterface) => x.unitNumber.localeCompare(y.unitNumber))
    .map((unit: UnitInterface, index: number) => {
      const currentContract = unit.getActiveContract();
      let tenantDisplayName = "";
      let unitNotEmpty = true;

      if (currentContract) {
        tenantDisplayName = currentContract?.tenantDisplayName;
      }

      emptyUnits.forEach(emptyUnit => {
        if (emptyUnit.id === unit.id) { unitNotEmpty = false; }
      });

      const unitRowStyles = !unit.isInactive ? {} :
        {color: "rgba(0, 0, 0, 0.28)", backgroundColor: "rgba(183, 183, 183, 0.2)"};

      return (
        <TableRow
          hover
          key={index}
          className={`clickable-entity`}
          style={unitRowStyles}
          onClick={() => {
            this.redirect(`/app/unit/update/${unit.id}`);
          }}
        >
          <TableCell style={{width: "30px"}}>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", width: "40px", marginBottom: "2px"}}>
              {unit.renderAvatar()}
            </div>
          </TableCell>
          <TableCell style={{maxWidth: "250px", width: "250px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{`${this.trans("title-unit")} ${unit.displayName}`}</TableCell>
          <TableCell style={{maxWidth: "300px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{unitNotEmpty && tenantDisplayName}</TableCell>
          <TableCell style={{width: "20px"}}>
            {this.renderTasksIcon(unit)}
          </TableCell>
          <TableCell style={{width: "20px"}}>
            {this.renderUnitAlertIcon(unit)}
          </TableCell>
          <TableCell
            onClick={e => {
              e.stopPropagation();
            }}
            style={{width: "50px", textAlign: "right"}}
          >
            <div>
              <IconButton
                onClick={e => this.openMenuUnits(e, unit)}
              >
                <div className="icon icon-ic-more-vert"></div>
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={this.state.anchorElUnits}
                open={Boolean(this.state.anchorElUnits) && this.selectedUnit && this.selectedUnit.id === unit.id}
                onClose={this.closeMenuUnits}
                disableAutoFocusItem={true}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left"
                }}
                getContentAnchorEl={null}
              >
                <MenuItem
                  key={`edit-btn`}
                  onClick={() => this.redirect(`/app/unit/update/${this.selectedUnit.id}`)}
                >
                  <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                </MenuItem>
                {/* <MenuItem
                  key={`de-activate-btn`}
                  onClick={() => this.changeActiveStatus(this.selectedUnit)}
                >
                  <ListItemIcon><div className="icon icon-ic-activate aligned"></div></ListItemIcon>
                  <ListItemText>{!!this.selectedUnit && !this.selectedUnit.isInactive ? this.trans("menuitem-deactivate") : this.trans("menuitem-activate")}</ListItemText>
                </MenuItem> */}
                {/* <MenuItem
                  key={`add-task-btn`}
                  onClick={() => this.setState({isNewTaskForUnitPopupOpen: true})}
                >
                  <ListItemIcon><div className="icon icon-ic-task aligned"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-create-task")}</ListItemText>
                </MenuItem> */}
                <MenuItem
                  key={`add-memo-btn`}
                  onClick={() => this.openMemoPopup(this.selectedUnit)}
                >
                  <ListItemIcon><div className="icon icon-ic-memo aligned"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-open-memo")}</ListItemText>
                </MenuItem>
                <MenuItem
                  key={`delete-btn`}
                  className="delete-action"
                  onClick={() => {
                    this.setState({
                      entity: unit,
                      isPromptOpen: true,
                      anchorElUnits: null
                    });
                  }}
                >
                  <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                </MenuItem>
                  {this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length > 0 && this.props.app.settings.agency.isActivitiesShown && (<Divider/>)}
                  {this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length > 0 && this.props.app.settings.agency.isActivitiesShown &&
                  <div
                     style={{
                       padding: "14px 16px",
                       fontSize: "12px", color: "gray",
                       outline: "0",
                       userSelect: "none"
                     }}
                   >{this.trans("menuitem-activities")}</div>}
                {
                  this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length > 0 && this.props.app.settings.agency.isActivitiesShown && (
                    this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).map((activityTemplate, key: number) => {
                      return (
                        <MenuItem
                          key={`activity-${key}`}
                          onClick={() => this.setState({
                            isCreateTasksFromActivityTemplatePopupOpen: true,
                            currentUnit: this.selectedUnit,
                            currentActivityTemplate: activityTemplate,
                            currentTenant: !!this.selectedUnit && unit.getActiveContract()
                                              && this.selectedUnit.getActiveContract().person
                                                && this.selectedUnit.getActiveContract().person.displayName,
                            anchorElUnits: null
                          })}
                        >
                          <ListItemIcon><div className="icon icon-ic-activity aligned"></div></ListItemIcon>
                          <ListItemText>{activityTemplate.name}</ListItemText>
                        </MenuItem>
                      )
                    })
                  )
                }
              </Menu>
            </div>
          </TableCell>
        </TableRow>
      );
    });
  }

  public openMemoPopup = (unit: UnitInterface) => {
    this.setState({
      currentUnit: unit, 
      unitNote: unit.note, 
      memoPopupOpen: true, 
      anchorElUnits: null
    });
  }
  public saveDraft = (message) => {
    this.setState({
    note: message,
  })}
  
  public saveReminder = (unit: UnitInterface) => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_UNIT_UPDATE_START,
        payload: {
          id: unit.id,
          unit: {
            note: this.state.unitNote
          }
        },
        onSuccess: () => this.setState({isSaving: false, memoPopupOpen: false}),
        onError: () => this.setState({isSaving: false, maxCharacterNumberForNotePopupOpen: true})
      });
    });
  }

  public removeReminder = (unit: UnitInterface) => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_UNIT_UPDATE_START,
        payload: {
          id: unit.id,
          unit: {
            note: ""
          }
        },
        onSuccess: () => this.setState({isSaving: false, memoPopupOpen: false}),
        onError: () => this.setState({isSaving: false})
      });
    });
  }

  public getNoteTipText = (note: string) => {
    const tipLength = 30;

    if (note.length > tipLength) {
      return `${note.slice(0, tipLength)}...`;
    }

    return note;
  }

  public getCompanyLogo = (): string => {
    if (!!this.state.selectedCompany) {
      return this.state.selectedCompany.avatar;
    }

    return this.image.get("company");
  }

  public getPropertyLogo = (): string => {
    if (!!this.state.property) {
      return this.state.property.avatar;
    }

    return this.image.get("property");
  }

  public getPersonAvatar = (): string => {
    if (!!this.state.selectedPerson) {
      return this.state.selectedPerson && this.state.selectedPerson.avatar;
    }

    return this.image.get("user");
  }

  public getAdditionalPayloadForPerson = (): any => {
    if (this.state.relateWithCompanyId === null) {
      return {};
    }

    return {
      companyId: this.state.relateWithCompanyId
    };
  }

  public deleteCharge = (charge: ChargeInterface): any => {
    if(charge?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_withdraw") || charge?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_deposit")){
      return this.setState({
        isChargeRemovePopupOpen: false,
        cannotDeleteSavingsChargeDialog: true
      });
    }

    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_DELETE_START,
        payload: {
          charge: charge
        },
        onSuccess: res => {
          this.fetchPropertyCharges(this.state.property.id);
  
          this.setState({
            deletedCharge: charge,
            removedPayments: res.data.data.removedPayments,
            paymentsFailedToRemove: res.data.data.paymentsFailedToRemove,
            isSaving: false
          }, () => {
            if (this.state.deletedCharge && this.state.deletedCharge.amountPaid > 0 && this.state.removedPayments.length === 0) {
              return this.props.dispatch({
                type: Constants.SNACKBAR_ADD_MESSAGE,
                payload: {
                  message: this.trans("textfield-charge-was-deleted-you-can-find-payments"),
                  type: "info"
                }
              });
            }
          });
        }
      });
    })
  }

  public onChangecontactInformationOfAssociation = (event) => {
    this.setState({
      hasModifiedData: true,
      contactInformationOfAssociation: event.target.value
    })
  }

  public renderInfoTab = () => {
    return (
      <div>
        <div className="component" style={{boxShadow: "0 3px 6px 0 rgb(0 0 0 / 10%)"}}>
          <PropertyCard 
            {...this.props}
            key={`propertycard-${this.state.property?.id}`}  
            property={this.state.property} 
            mainCardPresentation={true}
            editableFields={
              <div className="no-margins has-margin-bottom">
                <Card className="card">
                  <div style={{maxWidth: "420px"}}>
                    <form>
                      <AddressSelector
                        {...this.props}
                        autoFocus={false}
                        id="address"
                        name="address.googlePlaceId"
                        className="scroll-to-address"
                        required={true}
                        searchText={this.state.address.formattedAddress ? this.state.address.formattedAddress : null}
                        selectedAddress={this.state.address}
                        onSelect={this.sync.bind(this, this.syncronizers.VALUE, "address")}
                        onClear={this.sync.bind(this, this.syncronizers.VALUE, "address", {})}
                        sendFullAddress={true}
                        error={this.getErrorFor("address.googlePlaceId")}
                      />

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-complexName"
                        type="text"
                        label={this.trans("label-complex-name") + this.trans("field/optional")}
                        value={this.state.complexName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "complexName")}
                        variant="standard"
                        error={!!this.getErrorFor("complexName")}
                        helperText={this.getErrorFor("complexName")}
                      />  

                      <div style={{margin: "-14px 0"}}>
                        <CompanyLookup
                          {...this.props}
                          id="companyId"
                          name="companyId"
                          className="scroll-to-companyId"
                          ref="CompanyLookup"
                          isInlineBlock={true}
                          width="100%"
                          containerWidth="100%"
                          floatingLabelText={this.trans("dropdown-searchforowner-label")}
                          labelText={this.trans("dropdown-owner-label")}
                          buttonLabel={this.trans("dropdown-button-new-owner")}
                          noResultText={this.trans("dropdown-owner-notfound")}
                          autoSelectId={this.state.selectedCompany && this.state.selectedCompany.id}
                          onCreate={this.handleCreatedCompany}
                          onSelect={this.selectCompany}
                          onClear={this.clearCompany}
                          forceUpdatePage={true}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "propertyUpdate", "owner")}
                          error={this.getErrorFor("companyId")}
                          templateFor={"owner"}
                          filterAgency={true}
                          selectEntityName={this.selectEntityName}
                          shouldOpenCoachModal={true}
                          openPropertyOwnerCoachDialog={() => this.setState({openPrePropertyOwnerCoachDialog: true})}
                        />
                      </div>

                      <div style={{margin: "-14px 0"}}>
                        <PersonLookup
                          {...this.props}
                          id="managerId"
                          name="managerId"
                          ref="PersonLookup"
                          isInlineBlock={true}
                          width="100%"
                          containerWidth="100%"
                          addToPayload={this.getAdditionalPayloadForPerson()}
                          filter={true}
                          searchText={this.state.contact ? this.state.contact.displayName : ""}
                          floatingLabelText={this.trans("dropdown-searchformanager-label") + this.trans("field/optional")}
                          labelText={this.trans("dropdown-manager-label") + this.trans("field/optional")}
                          autoSelectId={this.state.selectedPerson && this.state.selectedPerson.id}
                          onCreate={this.handleCreatedPerson}
                          onSelect={this.selectPerson}
                          onClear={this.clearPerson}
                          buttonLabel={this.trans("dropdown-button-newmanager")}
                          noResultText={this.trans("dropdown-manager-notfound")}
                          forceUpdatePage={true}
                          filterAgency={true}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "propertyUpdate")}
                          templateFor={"caretaker"}
                        />
                      </div>

                      <div style={{margin: "-14px 0"}}>
                        <CompanyLookup
                          {...this.props}
                          id="companyId"
                          name="companyId"
                          // className="scroll-to-companyId"
                          forceUpdatePage={true}
                          autoSelectId={this.state.selectedAssociationOwner && this.state.selectedAssociationOwner.id}
                          ref="CompanyLookup"
                          isInlineBlock={true}
                          width="100%"
                          containerWidth="100%"
                          floatingLabelText={this.trans("page/propertycreate-field/associationownerid-label") + this.trans("field/optional")}
                          labelText={this.trans("page/propertycreate-field/associationownerid-label")}
                          searchText={this.state.selectedAssociationOwner ? this.state.selectedAssociationOwner.displayName : ""}
                          onSelect={this.selectAssociationOwner}
                          onClear={this.clearAssociationOwner}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "propertyUpdate", "associationOwner")}
                          noResultText={this.trans("dropdown-company-notfound")}
                          // error={this.getErrorFor("companyId")}
                          buttonLabel={this.trans("dropdown/company-button/propertyassociation")}
                          templateFor={"company"}
                          selectEntityName={this.selectEntityName}
                          shouldOpenCoachModal={true}
                          openPoaCoachDialog={() => this.setState({openPoaCoachDialog: true})}
                        />
                      </div>

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-contactInformationOfAssociation"
                        type="text"
                        label={this.trans("page/propertyupdate-section/property-tab/details-field/contactInformationOfAssociation-label") + this.trans("field/optional")}
                        value={this.state.contactInformationOfAssociation}
                        onChange={this.onChangecontactInformationOfAssociation}
                        variant="standard"
                        multiline
                        rowsMax="25"
                        error={!!this.getErrorFor("contactInformationOfAssociation")}
                        helperText={this.getErrorFor("contactInformationOfAssociation")}
                      />
                      
                      <TextField
                        autoComplete="off"
                        id="note"
                        name="note"
                        className="form-element full-size scroll-to-note"
                        type="text"
                        multiline={true}
                        rowsMax={10}
                        label={this.trans("note") + this.trans("field/optional")}
                        value={this.state.note}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                        variant="standard"
                        error={!!this.getErrorFor("note")}
                        helperText={this.getErrorFor("note")}
                      />
                    </form>
                  </div>
                </Card>
              </div>
            }
          />
        </div>

        <div style={{marginTop: "20px"}} className="component-wrapper no-margins has-margin-bottom no-shadow">
          <Card className="card no-padding">
            <div>       
              <div>
                {
                  this.state.property?.units
                    .sort((x: UnitInterface, y: UnitInterface) => x.unitNumber.localeCompare(y.unitNumber))
                    .filter((unit: UnitInterface) => !unit.removed)
                    .map((unit: UnitInterface) => {
                      return (
                        <div className="component-wrapper no-margins has-margin-bottom">
                          <div className="component">
                            <UnitCard 
                              key={`unit-${unit?.id}`}
                              unit={unit}
                            />
                          </div>
                        </div>
                      )
                    })
                }
              </div>  
            </div>
          </Card>
        </div>

        <div style={{marginTop: "20px"}} className="component-wrapper no-margins has-margin-bottom no-shadow">
          <Card className="card no-padding">
            <div>       
              <div>
                {
                  this.state.chargeTemplates
                    .map((chargeTemplate: ChargeTemplateInterface) => {
                      return (
                        <div className="component-wrapper no-margins has-margin-bottom">
                          <div className="component">
                            <ChargeTemplateCard 
                              key={`chargeTemplate-${chargeTemplate?.id}`}  
                              chargeTemplate={chargeTemplate} 
                              openChargeTemplate={() => this.setState({selectedChargeTemplate: chargeTemplate}, () => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate))}
                              removeChargeTemplate={() => this.setState({selectedChargeTemplate: chargeTemplate}, () => this.deleteChargeTemplate(this.state.selectedChargeTemplate))}
                            />
                          </div>
                        </div>
                      );
                    })
                }
              </div>  
            </div>
          </Card>
        </div>

        <div className="component-wrapper no-margins has-margin-bottom">
          <Attachment
            {...this.props}
            typeOfComponent="shared"
            possibilityToSetAvatar={true}
            title={this.trans("attachments-for-address")}
            amazonFolderName={this.state.amazonFolderName}
            relation="propertyId"
            entity={this.state.property}
            attachments={this.state.attachments}
            updateParentState={attachments => this.setState({attachments: attachments})}
            onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
            onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
            hint={this.trans("page/property-section/attachment-hint")}
            disabled={this.state.property?.isReadonly}
          />
        </div>
      </div>
    );
  }

  public renderFinanceTab = () => {
    return (
      <div className="component-wrapper no-margins has-margin-bottom">
        <Card className="card no-padding">
          <div className="label-container">
            <h3 className="card-title">
              {this.trans("balance-for-property")}
            </h3>

            <Button
              color="primary"
              onClick={() => {
                if (this.checkProcessIsBusy({
                                  action: "create",
                                  entityName: "charge",
                                  entity: this.state.property
                                })) {
                  this.openIsBusyPopup();
                } else {
                  this.props.dispatch({
                    type: Constants.PAGE_CHARGE_CREATE_ADD_PARAMS,
                    payload: {
                      propertyId: this.state.property && this.state.property.id
                    }
                  });

                  // this.openChargeCreatePopup();
                  this.setState({
                    isCoachNewChargeOpen: true
                  });
                }
              }}
              disabled={this.state.property?.isReadonly}
            >
              {this.trans("button-add-charge")}
            </Button>
          </div>

          <BalanceComponent
            {...this.props}
            balanceFor="property"
            balanceCharges={this.state.charges}
            deleteCharge={this.deleteCharge}
            fetchCharges={() => {
              this.fetchPropertyCharges(this.state.property.id);
            }}
            propertyId={this.state.property.id}
          />
        </Card>
      </div>
    );
  }

  public updatePropertyBankAccount = (event) => {
    const bankAccountId = event.target.value;

    if (bankAccountId === "" || !bankAccountId ) {
      return this.setState({
        agencyBankAccountId: ""
      });
    }

    this.props.dispatch({
      type: Constants.PAGE_PROPERTY_UPDATE_START,
      payload: {
        id: this.state.id,
        property: {
          address: { ...this.state.address },
          companyId: !this.state.selectedCompany ? null : this.state.selectedCompany.id,
          managerId: !this.state.selectedPerson  ? null : this.state.selectedPerson.id,
          contactInformationOfAssociation: this.state.contactInformationOfAssociation,
          associationOwnerId: !this.state.selectedAssociationOwner ? null : this.state.selectedAssociationOwner.id,
          note: this.state.note,
          agencyBankAccount: Number(bankAccountId),
          complexName: this.state.complexName
        }
      },
      onSuccess: () => {
        this.setState({
          agencyBankAccountId: String(bankAccountId)
        });
      },
      onError: () => {
        this.setState({
          hasModifiedData: true,
        });
      }
    });
  }

  public openAgencyFeeDialog = () => {
    return this.setState({
      isAgencyFeeDialogOpen: true
    });
  }

  public closeAgencyFeeDialog = () => {
    // sending empty error array to clear page errors
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
      payload: {
        err: []
      }
    });

    this.setState({
      isAgencyFeeDialogOpen: false,
      isUpdating: false
    });
  }

  public addAgencyFee = (agencyFee): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_START,
      payload: agencyFee,
      onSuccess: () => {
        this.closeAgencyFeeDialog();
      }
    });
  }

  public updateAgencyFee = (agencyFee: AgencyFeeInterface): any => {
    this.selectedAgencyFee = agencyFee;

    this.setState({
      isUpdating: true,
      anchorElAgencyFees: null
    }, () => {
      this.openAgencyFeeDialog();
    });
  }

  public saveAgencyFee = (agencyFee: AgencyFeeInterface): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_UPDATE_START,
      payload: agencyFee,
      onSuccess: () => {
        this.closeAgencyFeeDialog();
      }
    });
  }

  public deleteAgencyFee = () => {
    const agencyFee = this.state.agencyFee;

    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_DELETE_START,
      payload: agencyFee,
      onSuccess: () => {
        this.setState({isAgencyRemoveDialog: false, agencyFee: null});
      },
      onError: () => {
        this.setState({
          isAgencyRemoveDialog: false,
          agencyFee: null
        });
      }
    });
  }

  public getAgencyFeeDialogTitle = (): string => {
    return this.trans("dialog/agencyfee-title");
  }

  public getAgencyFeeDialogContent = (): any => {
    if (this.state.isUpdating) {
      return (
        <AgencyFeeUpdate
          {...this.props}
          agencyFee={this.selectedAgencyFee}
          onSave={this.saveAgencyFee}
          onCancel={this.closeAgencyFeeDialog}
        />
      );
    }

    return (
      <AgencyFeeCreate
        {...this.props}
        objectType={AgencyFeeContainer.pickIdFromLabel("Property")}
        objectId={this.state.property.id}
        onSave={this.addAgencyFee}
        onCancel={this.closeAgencyFeeDialog}
      />
    );
  }

  public getDefaultAgencyFees = () => {
    return this.state.property && this.state.property.defaultAgencyFees && this.state.property.defaultAgencyFees.map((agencyFee: AgencyFeeInterface) => {
      return (
        <TableRow
          hover
          key={agencyFee.id}
          className={`clickable-entity`}
          onClick={() => {
            this.updateAgencyFee(agencyFee);
          }}
        >
          <TableCell>
          </TableCell>
          <TableCell style={{width: "auto"}}>
            {this.formatter.formatNumber(agencyFee.fixedFee, agencyFee.currency)}
          </TableCell>
          <TableCell>{`${this.formatter.simpleFormatNumber(agencyFee.percentageFee, false)}%`}</TableCell>
          <TableCell>{this.formatter.checkTranslationType(this.trans(agencyFee.fixedPlusPercentageMode.label), agencyFee.fixedPlusPercentageMode.label)}</TableCell>
          <TableCell
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div>
              <IconButton
                onClick={e => this.openMenuAgencyFees(e, agencyFee)}
              >
                <div className="icon icon-ic-more-vert"></div>
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={this.state.anchorElAgencyFees}
                open={Boolean(this.state.anchorElAgencyFees) && this.selectedAgencyFee && this.selectedAgencyFee.id === agencyFee.id}
                onClose={this.closeMenuAgencyFees}
                disableAutoFocusItem={true}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left"
                }}
                getContentAnchorEl={null}
              >
                <MenuItem
                  onClick={() => this.updateAgencyFee(this.selectedAgencyFee)}
                >
                  <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                </MenuItem>
                <MenuItem
                  className="delete-action"
                  onClick={() => this.setState({ agencyFee: this.selectedAgencyFee, isAgencyRemoveDialog: true, anchorElAgencyFees: null})}
                >
                  <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                </MenuItem>
              </Menu>
            </div>
          </TableCell>
        </TableRow>
      );
    });
  }

  public renderBankAccountSettings = () => {
    return (
      <div>
        <div className="component-wrapper no-margins has-margin-top">
          <Card className="card no-padding">
            <div className="label-container">
              <h3 className="card-title">
                {this.trans("title-bank-account")}
              </h3>
              <div className="inner-wrapper-section">
                <h4>
                  {this.trans("page/propertyupdate-tab/settings-hint/bankaccount")}
                </h4>
              </div>
            </div>
            <div className="aling-to-left">
              <Select
                className="form-element form-input scroll-to-bank-account correct-label-position"
                error={this.getErrorFor("bank-account")}
                style={{width: "430px"}}
                disabled={this.state.property?.isReadonly}
                value={this.state.agencyBankAccountId}
                onChange={this.updatePropertyBankAccount}
                htmlFor="bankAccount"
                label={this.trans("label-bank-account")}
                name="bankAccount" 
                id="bankAccount"
              >
                {
                  this.getAgencyBankAccounts()
                    .map((bankAccount: BankAccountInterface, key: number) => {
                      return (
                        <MenuItem
                          key={`bankAccount-${key}`}
                          value={bankAccount.id}
                          className="filter-payment-item"
                        >
                        <div className="bank-account-menuitem-wrapper" style={{height: "23px"}}>
                          <div>{`${bankAccount.accountId ? `${bankAccount.accountId} - ` : ""} ${bankAccount.name !== "" && bankAccount.name ? `${bankAccount.name}` : ""}`}</div>
                        </div>
                        </MenuItem>
                      );
                    })
                  }
                <MenuItem
                  className="button-add-wrapper"
                >
                  <Button
                    className="color-button-add"
                    style={{width: "100%"}}
                    onClick={() => this.setState({isCreateBankAccountDialogOpen: true})}
                  >
                    {this.trans("add-bank-account")}
                  </Button>
                </MenuItem>
              </Select>
            </div>
          </Card>
        </div>
      </div>
    );
  }

  public renderSettingsTab = () => {
    return (
      <>
        <div>
          <div className="component-wrapper no-margins has-margin-bottom">
            <Card className="card no-padding">
              <div className="label-container">
                <h3 className="card-title">
                  {this.trans("section/agencyfee-table-title")}
                </h3>
                <div className="inner-wrapper-section">
                  <h4>
                    {this.trans("address/default-agreement-subtitle")}
                  </h4>
                </div>
              </div>
              <div>
              {
                <div style={{ padding: "20px 10px 20px 65px", maxWidth: "420px" }}>            
                  <Select
                    className={`form-element full-size form-input scroll-to-unitTypeId ${this.state?.assignmentServiceStatus ? "correct-label-position" : ""}`}
                    error={this.getErrorFor("assignmentServiceStatusId")}
                    value={this.state?.assignmentServiceStatus}
                    onChange={this.changeAssignmentServiceStatus}
                    htmlFor="assignmentServiceStatusId"
                    label={this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}
                    name="assignmentServiceStatus" 
                    id="assignmentServiceStatus"
                  >
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(2).toLowerCase()}`)}</MenuItem>
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(5).toLowerCase()}`)}</MenuItem>
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(4).toLowerCase()}`)}</MenuItem>
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(3).toLowerCase()}`)}</MenuItem>
                  </Select>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{display: "flex", flexDirection: "column", width: "70%", marginRight: "10px"}}>
                      <TextField
                        autoComplete="off"
                        className="full-size scroll-to-fixedFee"
                        type="text"
                        label={this.trans("dialog/agencyfee-field/fixedfee-label")}
                        value={this.state?.fixedFee}
                        onChange={this.changeFixedFeeAmount}
                        variant="standard"
                        error={!!this.getErrorFor("fixedFee")}
                        helperText={this.getErrorFor("fixedFee")}
                      />
                    </div>

                    <Select
                      className="form-input scroll-to-currency correct-label-position"
                      style={{width: "30%"}}
                      error={this.getErrorFor("currency")}
                      value={this.state.currency}
                      onChange={this.sync.bind(this, this.syncronizers.CURRENCY)}
                      htmlFor="currency"
                      name="currency" 
                      id="currency"
                      disabled={true}
                    >
                      {this.getCurrencySelectboxes()}
                    </Select>
                  </div>
                  <div className="hint-styles-dialog" style={{margin: "0"}}>
                    {this.trans("dialog/agencyfee-info/amount")}
                  </div>

                  <TextField
                    autoComplete="off"
                    className="form-element scroll-to-percentageFee"
                    type="text"
                    label={this.trans("dialog/agencyfee-field/percentagefee-label")}
                    value={this.state?.percentageFee}
                    onChange={this.changePercentageFeeAmount}
                    variant="standard"
                    error={!!this.getErrorFor("percentageFee")}
                    style={{width: "calc(70% - 7px)"}}
                  />
                  {!!this.getErrorFor("percentageFee") && <div className="component-error-text">{this.getErrorFor("percentageFee")}</div>}
                  <div className="hint-styles-dialog" style={{margin: "-14px 0 10px 0"}}>
                    {this.trans("dialog/agencyfee-info/percentagefee")}
                  </div>

                  <Select
                    className={`form-element full-size form-input scroll-to-repeat-period ${this.state?.repeatPeriod ? "correct-label-position" : ""}`}
                    error={this.getErrorFor("repeat-period")}
                    value={this.state?.repeatPeriod}
                    onChange={this.changeRepeatPeriod}
                    htmlFor="repeatPeriod"
                    label={this.trans("dialog/defaultchargetemplates-field/period-label")}
                    name="repeatPeriod" 
                    id="repeatPeriod"
                    // disabled={this.state?.assignmentServiceStatus === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")}
                  >
                    {this.getRepeatPeriodAgreementSelectboxes(this.state?.assignmentServiceStatus)}
                  </Select>

                  {parseFloat(this.state.percentageFee.replace(",", ".")) > 0 && (
                    <Select
                      className="form-element full-size form-input scroll-to-fixedPlusPercentageMode correct-label-position"
                      error={this.getErrorFor("fixedPlusPercentageMode")}
                      value={this.state?.fixedPlusPercentageMode && this.state?.fixedPlusPercentageMode.id}
                      onChange={this.updateFPPMode}
                      htmlFor="fixedPlusPercentageMode"
                      label={this.trans("dialog/agencyfee-field/fixedpluspercentagemode-label")}
                      name="fixedPlusPercentageMode"
                      id="fixedPlusPercentageMode"
                    >
                      {
                        Object.keys(this.props.globalTypes?.FixedPlusPercentageModes || {}).map((fpp) => {
                          let fpps = this.props.globalTypes?.FixedPlusPercentageModes?.[fpp];

                          return (
                            <MenuItem key={fpps.id} value={fpps.id}>{this.formatter.checkTranslationType(this.trans(fpps.label), fpps.label)}</MenuItem>
                          );
                        })
                      }
                    </Select>
                  )}
                </div>
              }
              </div>
            </Card>
          </div>
        </div>
        {this.renderBankAccountSettings()}
      </>
    );
  }

  
  public changeFixedFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    if (this.state?.agreementVat) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state?.vat)).replace(",", ".")).toFixed(2));
      vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

      let vatPercentage = vatNumber / (fixedFee - vatNumber) * 100;

      return this.setState({
        vatPercentage: isFinite(vatPercentage) ? this.formatter.simpleFormatNumber(Math.round(vatPercentage), false, false) : "",
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    if (this.state?.vatPercentage) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state?.vatPercentage)).replace(",", ".")).toFixed(2));
      vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

      const vatNumber = fixedFee / (100 + vatPercentageNumber) * vatPercentageNumber;

      return this.setState({
        agreementVat: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    return this.setState({
      agreementVat: "",
      vatPercentage: "",
      fixedFee: amount,
      hasModifiedData: true
    });
  }

  public changePercentageFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      percentageFee: amount,
      hasModifiedData: true
    });
  }

  public changeAssignmentServiceStatus  = (event) => {
    const type: number = event.target.value;
    this.clearBackEndErrors();

    this.setState({
      assignmentServiceStatus: type,
      repeatPeriod: type === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
      hasModifiedData: true
    });
  }

  public changeRepeatPeriod  = (event) => {
    const period: number = event.target.value;
    this.clearBackEndErrors();

    this.setState({
      repeatPeriod: period,
      hasModifiedData: true
    });
  }

  public updateFPPMode = (event) => {
    const fpp = this.props.globalTypes?.FixedPlusPercentageModes?.[event.target.value];

    this.setState({
      fixedPlusPercentageMode: fpp,
      hasModifiedData: true
    });
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }


  public defaultFixedPlusPercentageModes(label) {
    const chargeClass = this.props.globalTypes?.FixedPlusPercentageModes;
    for(const key in chargeClass) {
      if (chargeClass[key].label === label) {
        return chargeClass[key].id
      }
    }
  }

  public switchTab = (event, tabValue): any => {
    event

    this.setState({
      selectedTabIndex: tabValue
    });

    this.props.dispatch({
      type: Constants.PAGE_PROPERTY_UPDATE_SWITCH_TAB,
      payload: {
        index: tabValue,
        propertyId: this.state.property?.id
      }
    });
  }

  public addBankAccount = (bankAccount): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_START,
      payload: {
        bankAccount: bankAccount
      },
      onSuccess: bankAccount => {
        this.setState({isCreateBankAccountDialogOpen: false});

        this.props.dispatch({
          type: Constants.PAGE_PROPERTY_UPDATE_START,
          payload: {
            id: this.state.id,
            property: {
              address: { ...this.state.address },
              companyId: !this.state.selectedCompany ? null : this.state.selectedCompany.id,
              managerId: !this.state.selectedPerson ? null : this.state.selectedPerson.id,
              contactInformationOfAssociation: this.state.contactInformationOfAssociation,
              associationOwnerId: !this.state.selectedAssociationOwner ? null : this.state.selectedAssociationOwner.id,
              note: this.state.note,
              agencyBankAccount: bankAccount.id,
              complexName: this.state.complexName
            }
          },
          onSuccess: () => {
            this.setState({
              agencyBankAccountId: String(bankAccount.id)
            });
          },
          onError: () => {
            this.setState({
              hasModifiedData: true
            });
          }
        });
      }
    });
  }

  public fetchPropertyCharges = (propertyId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        propertyId: propertyId,
        isAfterStartDate: 1, // do not fetch charges before start date
      },
      onSuccess: data => {
        this.setState({charges: [...data.charges]});
      }
    });
  }

  public openChargeTemplateCreatePopup = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR,
    });

    this.setState({
      newChargeTemplatePopupOpen: true,
      isUpdating: false,
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true
      })
    });
  }

  public closeChargeTemplatePopup = () => {
    this.setState({
      isChargeTemplatePopupOpen: false,
      isUpdating: false
    });
  }

  public openChargeTemplateMenu = (event: any, chargeTemplate: ChargeTemplateInterface): void => {
    this.setState({
      selectedChargeTemplate: chargeTemplate,
      anchorElChargeTemplate: event.currentTarget
    });
  }

  public closeChargeTemplateMenu = (): void => {
    this.setState({
      anchorElChargeTemplate: null
    });
  }

  public addChargeTemplate = (chargeTemplate, callback?): any => {
    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_START,
        payload: {
          chargeTemplate: chargeTemplate,
          propertyId: this.state.property && this.state.property.id
        },
        onSuccess: createdChargeTemplate => {
          this.setState({
            isChargeTemplatePopupOpen: false,
            chargeTemplates: [...this.state.chargeTemplates, createdChargeTemplate],
            isSaving: false
          }, () => {
            if (typeof callback === "function") {
              callback();
            }
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    })
  }

  public openChargeTemplateUpdatePopup = (chargeTemplate: ChargeTemplateInterface): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR,
    });

    this.setState({
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      anchorElChargeTemplate: null,
      newChargeTemplatePopupOpen: false,
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true
      })
    });
  }

  public updateChargeTemplate = (updatedChargeTemplate: ChargeTemplateInterface): any => {
    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_START,
        payload: {
          chargeTemplate: updatedChargeTemplate
        },
        onSuccess: updatedChargeTemplate => {
          this.setState({
            isChargeTemplatePopupOpen: false,
            isUpdating: false,
            chargeTemplates: this.state.chargeTemplates.map(
              (chargeTemplate: ChargeTemplateInterface) => {
                if (chargeTemplate.id === updatedChargeTemplate.id) {
                  return chargeTemplate.reinitialize({...updatedChargeTemplate.data});
                }
  
                return chargeTemplate;
              }
            ),
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public deleteChargeTemplate = (chargeTemplate: ChargeTemplateInterface): any => {
    this.closeChargeTemplateMenu();

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_START,
      payload: {
        chargeTemplate: chargeTemplate
      },
      onSuccess: deletedChargeTemplate => {
        this.setState({
          chargeTemplates: [...this.state.chargeTemplates]
                             .filter(chargeTemplate => chargeTemplate.id !== deletedChargeTemplate.id)
        })
      },
      onError: () => {
        this.setState({
          isSaving: false
        });
      }
    });
  }

  public getChargeTemplatePopupContent = (): any => {
    if (this.state.isUpdating) {
      return (
        <ChargeTemplateUpdate
          {...this.props}
          entity={"property"}
          chargeTemplate={this.state.selectedChargeTemplate}
          onSave={this.updateChargeTemplate}
          onCancel={() => this.setState({isChargeTemplatePopupOpen: false})}
          showInformationText={true}
          disabled={this.state.property?.isReadonly}
        />
      );
    }

    return (
      <ChargeTemplateCreate
        {...this.props}
        entity={"property"}
        selectedType={TypeContainer.pickIdFromLabel("Owner_association_contribution")}
        onSave={this.addChargeTemplate}
        onCancel={() => this.setState({isChargeTemplatePopupOpen: false})}
        showInformationText={true}
        company={this.state.property?.associationOwner}
      />
    );
  }

  public getChargeTemplates = () => {
    return [...this.state.chargeTemplates]
      .map((chargeTemplate: ChargeTemplateInterface) => {
        return (
          <TableRow
            hover
            key={chargeTemplate.id}
            className={`clickable-entity`}
            onClick={() => {
              this.openChargeTemplateUpdatePopup(chargeTemplate);
            }}
          >
            <TableCell></TableCell>
            <TableCell style={{width:"20%"}}>
              {this.formatter.formatNumber(chargeTemplate.amount, chargeTemplate.currency)}
            </TableCell>
            <TableCell style={{width:"15%"}}>{this.formatter.checkTranslationType(this.trans(chargeTemplate.repeatPeriod.label), chargeTemplate.repeatPeriod.label)}</TableCell>
            <TableCell style={{width:"15%"}}>{this.formatter.checkTranslationType(this.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)}</TableCell>
            <TableCell style={{width:"5%"}}>{chargeTemplate?.isPaidDirectlyToOwner ? this.trans("label-direct") : ""}</TableCell>
            <TableCell style={{width:"15%"}}>{this.formatter.formatDate(chargeTemplate.dueDateFirstPayment) || this.formatter.formatDate(chargeTemplate.firstDate)}</TableCell>
            <TableCell style={{width:"15%"}}>{this.formatter.formatDate(chargeTemplate.endDate)}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openChargeTemplateMenu(e, chargeTemplate)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElChargeTemplate}
                  open={Boolean(this.state.anchorElChargeTemplate) && this.state.selectedChargeTemplate && this.state.selectedChargeTemplate.id === chargeTemplate.id}
                  onClose={this.closeChargeTemplateMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => this.deleteChargeTemplate(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  /* START Methods for 3-dot menu */

  protected openMenu = (event: any): void => {
    this.setState({
      anchorPropertyEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorPropertyEl: null
    });
  }

  protected openDeletePromptDialog = (entity: any): void => {
    this.setState({
      isDeletePromptOpen: true,
      entity: entity,
      anchorPropertyEl: null
    });
  }

  public closeDeletePrompt = (): void => {
    this.setState({
      isDeletePromptOpen: false,
      anchorPropertyEl: null
    });
  }

  /* FINISH Methods for 3-dot menu */


  public onCloseCoach = () => {
    this.setState({
      openPropertyOwnerCoachDialog: false,
      openPrePropertyOwnerCoachDialog: false,
      // ownerType: "",
      // ownerTypeСhose: false
    })
  }

  public openFirstStep = () => {
    this.setState({
      openPropertyOwnerCoachDialog: false,
      openPrePropertyOwnerCoachDialog: true,
      // ownerType: "",
      // ownerTypeСhose: false
    })
  }

  public setCompanyFromCoach = (company) => {
    this.setState({
      hasModifiedData: true,
      selectedCompany: company
    })
  }

  public getCoachContent = () => {
    return (
      <div>
        <div>
          {this.trans("coach/propertyowner-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.ownerType}
            onChange={this.chooseOwnerType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/propertyowner-radiobutton/person")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/propertyowner-radiobutton/company")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
          </RadioGroup>
        </div>
        <div className="hint-styles">
          {this.trans("coach/propertyowner-scenario/company-step/first-info2")}
        </div>
      </div>
    )
  }

  public chooseOwnerType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      ownerType: choice,
      ownerTypeСhose: true
    });
  }

  public selectEntityName = (name, type) => {
    this.setState({
      defaultCompanyName: type === "owner" ? name : "",
      defaultPoaCompanyName: type === "company" ? name : "",
    })
  }

  public onClosePoaCoach = () => {
    this.setState({
      openPoaCoachDialog: false,
      defaultPoaCompanyName: "",
      // ownerType: "",
      // ownerTypeСhose: false
    })
  }

  public setPoaCompanyFromCoach = (company) => {
    this.setState({
      hasModifiedData: true,
      selectedAssociationOwner: company
    })
  }

  public openChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: true
    });
  }

  public closeChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: false
    });
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button two-row-title">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <div className="title-wrapper">
                <h1>{this.trans("label-address")}</h1>
              </div>
              <div className="button-container">
                {
                  this.state.hasModifiedData && (
                    <Button
                      color="primary"
                      onClick={this.redirectBack}
                      style={{marginRight: "20px"}}
                    >
                      {this.trans("button-cancel")}
                    </Button>
                  )
                }
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.state.hasModifiedData ? this.save : this.redirectBack}
                  disabled={this.state.isSaving}
                >
                  {this.state.hasModifiedData ? this.trans("button-save") : this.trans("label-done")}
                </Button>
              </div>
            </div>
            <div className="inner-wrapper">
              <h4>{this.state.property && this.state.property.address && this.state.property.address.formattedAddress}</h4>
            </div>
          </div>

          <div className="box component-property-update">
            <div className="component-wrapper no-margin-top no-shadow">
              <div style={{position: "relative"}}>
                <Tabs
                  className="tab tab-simple tab-contains-3 half-size has-margin-bottom"
                  value={this.state.selectedTabIndex}
                  onChange={this.switchTab}
                >
                  <Tab label={this.trans("label-overview")} value={0} />
                  <Tab label={this.trans("label-finance")} value={1}
                    onClick={() => this.fetchPropertyCharges(this.state.property && this.state.property.id)}
                  />
                  <Tab style={{marginLeft: "auto", padding: "0 10px"}} label={this.trans("label-settings")} onClick={e => this.switchTab(e, 2)} value={2}/>
                </Tabs>
              </div>
              {this.state.selectedTabIndex === 0 && this.renderInfoTab()}
              {this.state.selectedTabIndex === 1 && this.renderFinanceTab()}
              {this.state.selectedTabIndex === 2 && this.renderSettingsTab()}
            </div>
          </div>

          {!this.state.property?.isReadonly && (
            <div className={"right-panel-wrapper"}>
            <EntityLaunchpanel
              {...this.props}
              entityTitle={this.trans("launchpanel-property-title")}
              actionsList={
                <List component="div" disablePadding>
                  <ListItem
                    button
                    key="create-unit-btn"
                    alignItems="flex-start"
                    // onClick={() => this.redirect(`/app/unit/create/${this.state.property.id}`)}
                    onClick={() => this.setState({
                      openCoachCreateNewUnit: true
                    })}
                    style={{padding: "1px 16px"}}
                  >
                    <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-unit"></div></ListItemIcon>
                    <ListItemText primary={this.trans("launchpanel/property-option/createunit")} secondary={this.trans("launchpanel/property-option/createunit-hint")} />
                  </ListItem>
                  <ListItem
                    button
                    alignItems="flex-start"
                    key={`menuitem-create-contract`}
                    // redirect user to /app/coach/new-bill-settlement
                    onClick={() => browserHistory.push("/app/coach/new-bill-settlement")}
                    style={{ padding: "1px 16px" }}
                  >
                    <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-contract"></div></ListItemIcon>
                    <ListItemText primary={this.trans("launch-panel-bill-settlement")} secondary={this.trans("hint/launch-panel-bill-settlement")} />
                  </ListItem>
                  <ListItem
                    button
                    key="create-charge-btn"
                    alignItems="flex-start"
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                                        action: "create",
                                        entityName: "charge",
                                        entity: this.state.property
                                      })) {
                        this.openIsBusyPopup();
                      } else {
                        this.props.dispatch({
                          type: Constants.PAGE_CHARGE_CREATE_ADD_PARAMS,
                          payload: {
                            propertyId: this.state.property && this.state.property.id
                          }
                        });
      
                        // this.openChargeCreatePopup();
                        this.setState({
                          isCoachNewChargeOpen: true
                        });
                      }
                    }}
                    style={{padding: "1px 16px"}}
                  >
                    <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-charge"></div></ListItemIcon>
                    <ListItemText primary={this.trans("launchpanel/property-option/createcharge")} secondary={this.trans("launchpanel/property-option/createcharge-hint")} />
                  </ListItem>
                  <ListItem
                    button
                    key="create-charge-template-btn"
                    alignItems="flex-start"
                    onClick={this.openChargeTemplateCreatePopup}
                    style={{padding: "1px 16px"}}
                  >
                    <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-charge"></div></ListItemIcon>
                    <ListItemText primary={this.trans("launchpanel/property-option/createchargetemplate")} secondary={this.trans("launchpanel/property-option/createchargetemplate-hint")} />
                  </ListItem>
                  <ListItem
                    button
                    key="create-task-btn"
                    alignItems="flex-start"
                    onClick={() => this.setState({isNewTaskForPropertyPopupOpen: true})}
                    style={{padding: "1px 16px"}}
                  >
                    <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-task"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-create-task")}</ListItemText>
                  </ListItem>
                  <ListItem
                    button
                    key="delete-btn"
                    alignItems="flex-start"
                    onClick={() => this.openDeletePromptDialog(this.state.property)}
                    style={{padding: "1px 16px"}}
                  >
                    <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-remove"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete-property")}</ListItemText>
                  </ListItem>
                </List>
              }
            />

              { 
                this.isBeta() && 
                <Timeline
                  {...this.props}
                  relations={{ propertyId: this.state.property && this.state.property.id }}
                  entityEvents={this.state.events}
                  fetchEntityEvents={this.fetchEntityEvents.bind(this, this.state.property && this.state.property.id)}
                  fetchingEvents={this.state.fetchingEvents}
                  property={this.state.property}
                />
              }    
            </div>
          )}
       
        </div>

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("memo")}
          content={
            <div>
              <Memo 
                {...this.props}
                entity={this.state.currentUnit}
                saveDraft={this.saveDraft}
                relations={{ unitId: this.state.currentUnit?.id }}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.saveReminder(this.state.currentUnit)}
          hideCross={true}
          subtitle={this.state.currentUnit?.displayName}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-warning")}
          content={this.trans("textfield-no-unpaid-charges-for-unit")}
          positiveButtonLabel={this.trans("button-close")}
          openLeavePrompt={this.state.showNoChargesDialog}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ showNoChargesDialog: false }); }}
          onSave={() => { this.setState({ showNoChargesDialog: false }); }}
          onlyPositiveButton={true}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'unit-remove-from-property-detail-page'}
          isOpen={this.state.isPromptOpen}
          onCancel={this.closePrompt}
          onDelete={this.delete}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'agency-fee-remove-from-settings-page'}
          isOpen={this.state.isAgencyRemoveDialog}
          onCancel={this.closePrompt}
          onDelete={this.deleteAgencyFee}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("error")}
          content={this.trans("memo-can-not-be-longer-than-255")}
          positiveButtonLabel={this.trans("button-close")}
          openLeavePrompt={this.state.maxCharacterNumberForNotePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ maxCharacterNumberForNotePopupOpen: false }); }}
          onSave={() => { this.setState({ maxCharacterNumberForNotePopupOpen: false }); }}
          onlyPositiveButton={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("create-tasks-for", {activityTemplate: this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : ""})}
          content={this.trans("you-are-about-to-create-task-for-activity-for-property", {activityTemplate : this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : "", property: this.state.property ? this.state.property.displayName : ""})}
          openLeavePrompt={this.state.isCreateTasksFromActivityTemplatePopupOpen}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("create-tasks")}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isCreateTasksFromActivityTemplatePopupOpen: false }); }}
          onSave={() => { this.setState({ isCreateTasksFromActivityTemplatePopupOpen: false }, () => {
            this.props.dispatch({
              type: Constants.PAGE_ACTIVITY_CREATE_ADD_PARAMS,
              payload: {
                propertyId: this.state.property && this.state.property.id
              }
            });

            this.redirect(`/app/activity/create/${this.state.currentActivityTemplate && this.state.currentActivityTemplate.id}/${this.state.property && this.state.property.id}/0`);
          })}}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={
            <div>
              <span>{this.trans("title-remove-savings-payment-warning")}</span>
            </div>}
          openLeavePrompt={this.state.cannotDeleteSavingsChargeDialog}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.setState({cannotDeleteSavingsChargeDialog: false})}
          onlyPositiveButton={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-bank-account")}
          content={
          <BankAccountCreate
            {...this.props}
            onSave={this.addBankAccount}
            onClose={() => this.setState({isCreateBankAccountDialogOpen: false})}
          />}
          openLeavePrompt={this.state.isCreateBankAccountDialogOpen}
          onClose={() =>{
            this.setState({isCreateBankAccountDialogOpen: false})
            this.props.dispatch({
              type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_CLEAR,
            })
          }}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />

        <CoachDialog
          {...this.props}
          openPropertyOwnerCoachDialog={this.state.openPropertyOwnerCoachDialog}
          type={this.state.ownerType}
          onCloseCoach={this.onCloseCoach}
          openFirstStep={this.openFirstStep}
          defaultCompanyName={this.state.defaultCompanyName}
          setCompanyFromCoach={this.setCompanyFromCoach}
        />

        <CoachPoaDialog
          {...this.props}
          openPoaCoachDialog={this.state.openPoaCoachDialog}
          type={"company"}
          onClosePoaCoach={this.onClosePoaCoach}
          defaultPoaCompanyName={this.state.defaultPoaCompanyName}
          setPoaCompanyFromCoach={this.setPoaCompanyFromCoach}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("coach/propertyowner-title")}
          innerDialogClasses="coach-owner dialog-assistant"
          content={this.getCoachContent()}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("coach/propertyowner-button/next")}
          openLeavePrompt={this.state.openPrePropertyOwnerCoachDialog}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              openPrePropertyOwnerCoachDialog: false,
              // ownerType: "",
              // ownerTypeСhose: false
            });
          }}
          onSave={() => { this.setState({ openPrePropertyOwnerCoachDialog: false, openPropertyOwnerCoachDialog: true }); }}
          diableContinueButton={!this.state.ownerTypeСhose}
        />

        <PromptDialog
          {...this.props}
          title={this.state.newChargeTemplatePopupOpen ? this.trans("title-property-new-price") : this.trans("title-property-price")}
          content={this.getChargeTemplatePopupContent()}
          openLeavePrompt={this.state.isChargeTemplatePopupOpen}
          onClose={this.closeChargeTemplatePopup}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />

        <DeleteEntityPrompt
          {...this.props}
          isOpen={this.state.isDeletePromptOpen}
          onCancel={this.closeDeletePrompt}
          onDelete={this.delete}
        />

        <ChargeCreateDialog 
          isOpened={this.state.isChargeCreatePopupOpen}
          title={this.trans("title-new-charge")}
          selectedEntity={this.state.property}
          onCancel={this.closeChargeCreatePopup}
          {...this.props}
        />

        {this.state.isCoachNewChargeOpen && (
        <CoachNewCharge
          {...this.props}
          openCoach={this.state.isCoachNewChargeOpen}
          selectedObjectForNewCharge={this.state.property}
          onCloseCoach={(success: boolean = false, charge) => {
            this.setState({
              isCoachNewChargeOpen: false
            }, () => {
              if (success) {
                return this.redirect(`/app/charge/update/${charge.id}`)
              }
            })
          }}
          selectedOwnerForNewCharge={this.state.property?.company || null}
          defaultChargeTypeId={TypeContainer.pickIdFromLabel("Other_receivable")}
          defaultChargeTypeLabel={"Other_receivable"}
        />
        )}

        <CreateTaskDialog 
          {...this.props}
          entity={this.selectedUnit}
          isOpen={this.state.isNewTaskForUnitPopupOpen}

          closeDialog={() => {
            this.setState({
              isNewTaskForUnitPopupOpen: false,
              isSaving: false, 
              anchorElUnits: null
            })
          }}
        />

        <CreateTaskDialog 
          {...this.props}
          entity={this.state.property}
          isOpen={this.state.isNewTaskForPropertyPopupOpen}

          closeDialog={() => {
            this.setState({
              isNewTaskForPropertyPopupOpen: false,
              isSaving: false, 
              anchorPropertyEl: null
            })
          }}
        />

        {this.state.openCoachCreateNewUnit && (
        <CoachNewUnitDialog
          {...this.props}
          openCoachCreateNewUnit={this.state.openCoachCreateNewUnit}
          notRedirectAfterFinish={true}
          onCloseUnitCoach={() => {
            this.setState({
              openCoachCreateNewUnit: false
            })
          }}
          property={this.state.property}
          activeStep={2}
        />
        )}

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    charges: state.charges,
    properties: state.properties,
    units: state.units,
    component: state.propertyUpdate,
    globalTypes: state.globalTypes,
    bankAccountCreate: state.bankAccountCreate,
    chargeTemplateCreate: state.chargeTemplateCreate,
    chargeTemplateUpdate: state.chargeTemplateUpdate,
  };
};

export default connect(mapStateToProps)(
  PropertyUpdate
);
